import { Country, State } from 'country-state-city';

export interface CountryType {
  value: string;
  label: string;
}

export interface StateType {
  value: string;
  label: string;
}

export const getAllCountries = (): CountryType[] => {
  return Country.getAllCountries().map((country) => ({
    value: country.isoCode,
    label: country.name,
  }));
};

export const getStatesOfCountry = (countryCode: string): StateType[] => {
  return State.getStatesOfCountry(countryCode).map((state) => ({
    value: state.name,
    label: state.name,
  }));
};